import { _createClient as createAuth0Client } from '@/features/authentication/utils/authentication/client/auth0/client'

export interface GetAccessTokenOptions {
  forceRefresh?: boolean
}

export interface LogoutOptions {
  /**
   * Used for having a custom returnTo param in the URL that the user will be redirected to after logging out
   */
  redirectUrl?: string
}

export interface AuthClient {
  /**
   * Returns a Promise that resolves to an access token. If necessary (or the forceRefresh option is passed),
   * the token will be refreshed and the new token will be returned.
   * @param options Options consist of the ssrContext (required on server) and a forceRefresh boolean,
   * which can be used to refresh the token before it is necessary
   * @returns a Promise that resolves to an access token
   */
  getAccessToken: (options?: GetAccessTokenOptions) => Promise<string | undefined>
  getIsTokenExpired: () => Promise<boolean>
}

let auth0Client: AuthClient | undefined

/**
 * The public interface for retrieving the auth client used for obtaining access
 * tokens, etc. This function will return auth0 client.
 * @returns The auth client
 */
export const getAuthClient = () => {
  if (!auth0Client) {
    auth0Client = createAuth0Client()
  }
  return auth0Client
}
